import { width } from '@openeducation/hr-rn-components';
import { styledTheme, useStylesDirection } from '@openeducation/hr-rn-themes';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import React, { memo, useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import { View } from 'react-native';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface StudentsHorizontalBarChartProps {
  labels: string[];
  values: number[];
  barsColor: string;
}

const StudentsHorizontalBarChart = ({
  labels,
  values,
  barsColor,
}: StudentsHorizontalBarChartProps) => {
  const isEmpty = values.every((value: number) => value === 0);

  const { font } = useStylesDirection();
  const options = useMemo(
    () => ({
      responsive: true,
      indexAxis: 'y',
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
        tooltip: {
          displayColors: false,
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
          },
          ticks: {
            color: styledTheme.color.dark3,
            font: {
              size: 10,
              family: font.semiBold.fontFamily,
            },
          },
          suggestedMax: isEmpty ? 10 : undefined,
        },
        y: {
          grid: {
            display: false,
          },
          ticks: {
            color: styledTheme.color.black,
            font: {
              size: 14,
              family: font.semiBold.fontFamily,
            },
          },
        },
      },
    }),
    [font, isEmpty]
  );

  const dataset = useMemo(
    () => ({
      labels,
      datasets: [
        {
          label: '',
          data: values,
          backgroundColor: barsColor,
          borderRadius: 4,
          barThickness: 20,
        },
      ],
    }),
    [barsColor, labels, values]
  );

  return (
    <View style={[width(1000)]}>
      <Bar options={options as any} data={dataset} />
    </View>
  );
};

export default memo(StudentsHorizontalBarChart);
